import { render } from "./createInBill.vue?vue&type=template&id=0f23df36&scoped=true&ts=true"
import script from "./createInBill.vue?vue&type=script&lang=ts"
export * from "./createInBill.vue?vue&type=script&lang=ts"

import "./createInBill.vue?vue&type=style&index=0&id=0f23df36&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f23df36"]])

export default __exports__